import { render } from "./PopupBtn2.vue?vue&type=template&id=ddbcfd88&scoped=true"
import script from "./PopupBtn2.vue?vue&type=script&lang=js"
export * from "./PopupBtn2.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=ddbcfd88&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddbcfd88"]])

export default __exports__